export const featuredPortfolio = [
    {
        id: 1,
        title: "MarketPlace",
        img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
        link: "https://github.com/MohanadSafwat/DS-Project"
    },
    {
      id: 2,
      title: "Dr.care",
      img: "https://cdn.dribbble.com/users/3967258/screenshots/15463803/media/4fddb9a2caf3b3bd634060f706a91e73.png?compress=1&resize=1200x900",
      link: "https://mohanadsafwat.github.io/Drcare/"

    },
    {
      id: 3,
      title: "To Do List",
      img: "https://cdn.dribbble.com/users/3637068/screenshots/15467010/media/69a3279182b75365013fe285733d1122.png?compress=1&resize=1200x900",
      link: "https://github.com/MohanadSafwat/To-Do-List"

    },
    {
      id: 4,
      title: "Weather Journal App",
      img: "https://cdn.dribbble.com/users/2264844/screenshots/15463998/media/d85e92a332c41094f68e1f716884f7ce.jpg?compress=1&resize=1200x900",
      link: "https://github.com/MohanadSafwat/Weather-Journal-App"

    },
    {
      id: 5,
      title: "Keeper App",
      img: "https://cdn.dribbble.com/users/387658/screenshots/15458608/media/e92ec1dd33dd1170ae3dc9c5272f2693.jpg?compress=1&resize=1200x900",
      link: "https://github.com/MohanadSafwat/Keeper-App "

    },
    {
        id: 6,
        title: "Matjar App",
        img: "https://cdn.dribbble.com/users/2597268/screenshots/15468893/media/44313553d73ba41580f1df69749bba28.jpg?compress=1&resize=1200x900",
        link: "https://github.com/MohanadSafwat/Matjar-App"

      },
  ];
  
  export const webPortfolio = [
    {
        id: 1,
        title: "MarketPlace",
        img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
        link: "https://github.com/MohanadSafwat/DS-Project"

    },
    {
      id: 2,
      title: "Dr.care",
      img: "https://cdn.dribbble.com/users/3967258/screenshots/15463803/media/4fddb9a2caf3b3bd634060f706a91e73.png?compress=1&resize=1200x900",
      link: "https://mohanadsafwat.github.io/Drcare/"

    },
    {
      id: 3,
      title: "To Do List",
      img: "https://cdn.dribbble.com/users/3637068/screenshots/15467010/media/69a3279182b75365013fe285733d1122.png?compress=1&resize=1200x900",
      link: "https://github.com/MohanadSafwat/To-Do-List"

    },
    {
      id: 4,
      title: "Weather Journal App",
      img: "https://cdn.dribbble.com/users/2264844/screenshots/15463998/media/d85e92a332c41094f68e1f716884f7ce.jpg?compress=1&resize=1200x900",
      link: "https://github.com/MohanadSafwat/Weather-Journal-App"

    },
    {
      id: 5,
      title: "Keeper App",
      img: "https://cdn.dribbble.com/users/387658/screenshots/15458608/media/e92ec1dd33dd1170ae3dc9c5272f2693.jpg?compress=1&resize=1200x900",
      link: "https://github.com/MohanadSafwat/Keeper-App "

    },
  ];
  
  export const mobilePortfolio = [
    {
      id: 1,
      title: "Matjar App",
      img: "https://cdn.dribbble.com/users/2597268/screenshots/15468893/media/44313553d73ba41580f1df69749bba28.jpg?compress=1&resize=1200x900",
      link: "https://github.com/MohanadSafwat/Matjar-App"

    },
  ];